module.exports = __webpack_public_path__ + "static/patterns-spacing-7cd881794dfd6534c3759ad437da34b0.png";